import { Grid, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const spanDefaultStyles = {
  fontFamily: "Manrope",
  fontSize: 16,
  color: colors.gray600,
};

export const WrapperTitle = styled("div")(() => ({
  paddingBottom: 16,
}));

export const WrapperInfoForm = styled(Grid)(() => ({
  paddingBottom: 16,
}));

export const WrapperInfoField = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
}));

export const FieldLabel = styled("span")(() => ({
  ...spanDefaultStyles,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: 0.1,

  display: "flex",
  alignItems: "center",
  gap: 4,
}));

export const FieldText = styled("span")(() => ({
  ...spanDefaultStyles,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,

  display: "flex",
  overflow: "hidden",
  whiteSpace: "pre-wrap",
  width: "100%",
}));

export const Counter = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,

  width: 18,
  height: 18,
  padding: 4,
  borderRadius: 100,
  backgroundColor: colors.gray500,

  color: colors.white,
  fontSize: 12,
  cursor: "default",
}));

export const WrapperWithInfoTag = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  "@media screen and (min-width: 1024px)": {
    "&:hover": {
      "& > div": {
        display: "flex",
      },
    },

    transition: "display 0.3s ease-in-out",
  },
}));

export const InfoTag = styled("div")(() => ({
  "@media screen and (min-width: 1024px)": {
    display: "none",
  },

  display: "flex",
  cursor: "pointer",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,

  width: 36,
  height: 36,
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "#66708514",
  },
  transition: "backgroundColor 0.5s ease-in-out",
}));

// NOT BEEN USED AT THIS THIME
export const Subtitle = styled("span")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "4px",

  fontSize: "14px",
  fontWeight: 600,
  color: "#475467",
  whiteSpace: "nowrap",
  fontFamily: "Manrope",
  letterSpacing: "0.1px",
  lineHeight: "20px",
}));

export const Information = styled("p")(() => ({
  color: "#465869",
  fontSize: "16px",
  fontWeight: 400,
  fontFamily: "Manrope",
  letterSpacing: "0.5px",
  lineHeight: "24px",
  marginBottom: "24px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: "inherit",
}));

export const ShipmentInfoItemWrapper = styled(Grid)(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  width: "100%",

  "&:hover": {
    "& > div": {
      opacity: "1",
    },
  },

  transition: "opacity 0.5s ease-in-out",
}));

export const ShipmenInfoItemWrapperVertical = styled(ShipmentInfoItemWrapper)(() => ({
  alignItems: "flex-start",
  flexDirection: "column",
  justifyContent: "flex-start",
}));

export const ShipmentDetailItem = styled(Grid)(() => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: "0",

  height: "44px",
  width: "100%",

  "@media (min-width: 1024px)": {
    maxWidth: "50%",
  },
}));

export const AgentInfoModalButton = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  borderRadius: "8px",
  height: "32px",
  width: "32px",
  padding: "4px",

  cursor: "pointer",
  transition: "opacity 0.5s ease-in-out",

  "&:hover": {
    backgroundColor: "#66708514",
  },

  "@media (min-width: 1024px)": {
    opacity: "0",
  },
}));

export const AgentInfoModalCopyButton = styled(AgentInfoModalButton)(() => ({
  padding: "12px",
}));

export const AgentInfosModalItemsWrapper = styled(Grid)(() => ({
  justifyContent: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: "24px",

  width: "100%",
}));

export const AgentInfoItemWrapper = styled(Grid)(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  width: "100%",

  "&:hover": {
    "& > div": {
      opacity: "1",
    },
  },

  transition: "opacity 0.5s ease-in-out",
}));

export const AgentInfoItemWrapperVertical = styled(AgentInfoItemWrapper)(() => ({
  alignItems: "flex-start",
  flexDirection: "column",
  justifyContent: "flex-start",
}));

export const AgentInfoItem = styled(ShipmentDetailItem)(() => ({
  width: "100%",
}));

export const AgentInfoModalCloseButton = styled("button")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  background: "transparent",
  border: "0",
  color: "#475467",
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  outline: "none",
  padding: "10px 12px",

  cursor: "pointer",
}));

export const ValueCountTag = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  background: "#667085",
  borderRadius: "100px",
  color: "#FFFFFF",
  fontFamily: "Manrope",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 600,
  height: "16px",
  lineHeight: "16px",
  letterSpacing: "0.5px",
  padding: "1px",
  textAlign: "center",
  width: "16px",

  cursor: "default",
}));

const useStyles = makeStyles(() => ({
  modalBody: {
    maxWidth: "394px !important",
    width: "100% !important",
  },
}));

export default useStyles;
